<router-outlet name="mc-sidebar"></router-outlet>
<div class="mapping-container" *ngIf="fullData$ | async as fullData">

  <div class="view-misc-info">

    <div class="view-info">
      <p>
        <strong>
          <span i18n="cantidad metas | cuenta de metas totales@@cuentaMetasTotales">{{fullData.metas.length}}
            metas </span>
          <span *ngIf="fullData.unidades.length > 0"
            i18n="cantidad unidades | cuenta de unidades totales@@cuentaunidadesTotales"> y
            {{fullData.unidades.length}}
            unidades</span>
          <span i18n="encontradas texto | texto encontradas@@encontradas"> encontradas. </span>
        </strong>
        <strong i18n="materias | materias@@materias">Materias</strong> {{textoBusquedaAreas}}
        <strong i18n="grados | grados@@grados">Grados:</strong> {{textoBusquedaCursos}}
      </p>
    </div>

    <div class="tools">
      <div style="display: flex;">
        <button [mat-menu-trigger-for]="menuDoc" #trial="matMenuTrigger" style="visibility: hidden">
        </button>
        <mat-menu #menuDoc="matMenu" xPosition="after" yPosition="below">
          <ng-container *ngFor="let item of menuDocs$ | async">
            <button mat-menu-item [routerLink]="item.item2">{{item.item1}}</button>
          </ng-container>
        </mat-menu>
        <button *ngIf="documentos" mat-button color="primary" (click)="openMenu()"
          i18n="documentacion botón | botón documentacion@@btnDocumentacion">
          <mat-icon>insert_drive_file</mat-icon>
          <span class="hide-label">Documentación</span>
        </button>
      </div>
      <button mat-button color="primary" i18n="@@filtrosVisualizacion" (click)="filtersStatus = !filtersStatus">
        <mat-icon>filter_list</mat-icon>
        <span class="hide-label">Filtros y visualización</span>
      </button>
      <button mat-button color="primary" i18n="@@busqueda" (click)="abrirBusqueda()">
        <mat-icon>search</mat-icon>
        <span class="hide-label">Buscar</span>
      </button>
    </div>

  </div>

  <div class="flex-wrap bulkActions">
    <div *ngIf="botonesConexionesVisibilidad" class="bulk-actions">
      <button style="margin-right: 16px;" mat-raised-button color="primary" (click)="limpiarConexiones()"
        i18n="botón limpiar conexiones | botón limpiar conexiones@@btnLimpiarConexiones">Limpiar conexiones
      </button>
      <button mat-button (click)="verConexionesActivas(!getActiveConexionsBool())"
        i18n="ver conexiones | ver conexiones@@btnVerConexiones">
        <span *ngIf="getActiveConexionsBool();else verConectadas">Ver todo</span>
        <ng-template #verConectadas>Ver solo conectadas</ng-template>
      </button>
    </div>
  </div>

  <div class="mapping">
    <div class="goals-container">
      <ng-container *ngFor="let categoria of categoriasMetas">
        <ng-container *ngIf="categoria.visible">
          <section class="categoria--metas" *ngIf="categoria.ordenAgrupador <= 2">
            <h4 class="mat-h4" style="display: flex; align-items: center;">
              {{categoria.nombre}} ({{(fullData.metas|categoriaFilter: [categoria.ordenAgrupador]).length}}) <button style="margin-left: 8px;" *ngIf="importar" mat-button (click)="abrirModalMetas('importar', categoria)" color="primary"><mat-icon>get_app</mat-icon>Importar</button>
            </h4>
            <ul>
              <ng-container *ngFor="let meta of fullData.metas | categoriaFilter: [categoria.ordenAgrupador]">
                <li>
                  <meta-mapa [meta]="meta" (onEdit)="abrirDialog('meta', $event)"></meta-mapa>
                </li>
              </ng-container>
            </ul>
          </section>
          <section class="categoria--metas" *ngIf="categoria.ordenAgrupador > 2">
            <h4 class="mat-h4">{{categoria.agrupador}}<button *ngIf="importar"  mat-button style="margin-left: 8px;" (click)="abrirModalMetas('importar', categoria)" color="primary"><mat-icon>get_app</mat-icon>Importar</button></h4>
            <mat-accordion multi="true">
              <ng-container *ngFor="let subCategoria of categoria.categorias">
                <mat-expansion-panel [expanded]="true">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{subCategoria.nombre}} ({{(fullData.metas|categoriaFilter: [subCategoria.id]).length}})
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <ul>
                    <ng-container *ngFor="let meta of fullData.metas | categoriaFilter: [subCategoria.id]">
                      <li>
                        <meta-mapa [meta]="meta" (onEdit)="abrirDialog('meta', $event)"></meta-mapa>
                      </li>
                    </ng-container>
                  </ul>
                </mat-expansion-panel>
              </ng-container>
            </mat-accordion>
          </section>
        </ng-container>
      </ng-container>
      <section class="categoria--metas" *ngIf="fullData.unidades.length > 0">
        <h4 class="mat-h4" i18n="label unidades | label cabecera unidades@@unidadesHeader" style="margin-bottom: 22px;margin-top: 6px;">Unidades</h4>
        <ng-container *ngIf="fullData.unidades.length > 0">
          <ng-container *ngFor="let periodo of periodos">
            <mat-accordion *ngIf="periodo.show">
              <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    {{periodo.nombre}}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <ul #unitListYear>
                  <ng-container *ngFor="let unidad of fullData.unidades">
                    <li *ngIf="unidad.periodo.id === periodo.id">
                      <unidad-mapa [unidad]="unidad" (onEdit)="abrirDialog('unidad', $event)"></unidad-mapa>
                    </li>
                  </ng-container>
                </ul>
              </mat-expansion-panel>
            </mat-accordion>
          </ng-container>

        </ng-container>
      </section>
    </div>
    <div class="mapping-filters" [hidden]="!filtersStatus" *ngIf="dataReady">
      <h3 class="mat-h3">Filtros y visualización</h3>
      <h4 class="mat-h4">
        <mat-slide-toggle color="primary" (change)="setAccordionsState($event.checked)" [checked]="true"
          labelPosition="before" #control>{{control.checked ? 'Contraer' : 'Expandir'}}
        </mat-slide-toggle>
      </h4>
      <mapa-curricular-filtros
        (selectedColumn)="getMetasColumnData($event)"
        (unitsByYear)="getUnitsDataByYear($event)"
        (hideMe)="filtersStatus = $event"
        (cleanConnections)="limpiarConexiones()"
        (showConnectedOnly)="verConexionesActivas(!getActiveConexionsBool())"
        [showBulkActions]="botonesConexionesVisibilidad" [activeConnections]="getActiveConexionsBool()"
        [periodos]="periodos">
      </mapa-curricular-filtros>
    </div>
  </div>
  <!-- 
  <button mat-fab color="primary" style="position: fixed; right: 2%; bottom: 2%; z-index: 500"
    [mat-menu-trigger-for]="menuMapa">
    <i class="material-icons">add</i>
  </button>
  <mat-menu [overlapTrigger]="true" yPosition="below" #menuMapa="matMenu">
    <button mat-menu-item (click)="abrirDialog('unidad', null)"
      i18n="botón creador de unidad | botón creador unidad@@btnCrearUnidad">
      Crear unidad
    </button>
    <button mat-menu-item (click)="abrirDialog('meta', null)"
      i18n="botón creador de meta | botón creador meta@@btnCrearMeta">
      Crear meta
    </button>
      <button mat-menu-item (click)="abrirModalMetas('importar')">
      Importar metas
    </button> 
  </mat-menu>
  -->
</div>
